/**
 * @flow
 */
'use strict';

export const iopDrugCodes = [
{"code":"Benoxinate + Fluorescein"},
{"code":"Proparacaine + Fluorescein"},
{"code":"Proparacaine"}
]

export const tonometryTestCodes = [
{"code":"Goldmann / ATN"},
{"code":"Air puff / NCT"},
{"code":"Perkins"},
{"code":"Tactile"},
]
